import { v4 as uid } from 'uuid';

type NotificationInAppType = 'info' | 'error' | 'danger' | 'success';

export interface NotificationInApp {
  id: string;
  type: NotificationInAppType;
  title?: string;
  text: string;
  duration: number;
  closeOnClick: boolean;
  timer: any;
  route?: string;
}

type NotificationOptions = {
  text: string;
  type?: NotificationInAppType;
  title?: string;
  duration?: number;
  closeOnClick?: boolean;
  route?: string;
};

const DEFAULT_OPTIONS = {
  type: 'success' as NotificationInAppType,
  duration: 3000,
  closeOnClick: false,
};

const useNotification = () => {
  const configStore = useConfigStore();

  const resetNotifications = () => {
    configStore.setNotificationsInApp([]);
  };

  const closeNotification = (notificationId: string) => {
    const index = configStore.notificationsInApp.findIndex(
      ({ id }) => id === notificationId,
    );
    if (index > -1) {
      clearTimeout(configStore.notificationsInApp[index].timer);
      const notifications = [...configStore.notificationsInApp];
      notifications.splice(index, 1);
      configStore.setNotificationsInApp(notifications);
    }
  };

  const displayNotification = (
    notificationOptions: string | NotificationOptions,
  ) => {
    if (typeof notificationOptions === 'string') {
      notificationOptions = {
        text: notificationOptions,
      } as NotificationOptions;
    }

    const newNotification = {
      id: uid(),
      ...DEFAULT_OPTIONS,
      ...notificationOptions,
    };

    const close = () => {
      closeNotification(newNotification.id);
    };

    let timer = null;
    if (!newNotification.closeOnClick) {
      timer = setTimeout(() => {
        close();
      }, newNotification.duration);
    }

    const notifications = [...configStore.notificationsInApp];
    configStore.setNotificationsInApp([
      ...notifications,
      { ...newNotification, timer },
    ]);

    return { id: newNotification.id, close };
  };

  const infoNotification = (type: string) => {
    return {
      id: type,
      type: (type === 'intro' ? 'info' : 'danger') as NotificationInAppType,
      textBold: type === 'intro' ? 'infos.intro-video.text-bold' : null,
      text:
        type === 'intro'
          ? 'infos.intro-video.text'
          : 'infos.version-deprecated',
      link:
        type === 'intro'
          ? {
              text: 'infos.intro-video.link-text',
              url: 'infos.intro-video.link-url',
            }
          : null,
      duration: 0,
      timer: 0,
      closeOnClick: false,
    };
  };

  return {
    notify: displayNotification,
    closeNotification,
    resetNotifications,
    infoNotification,
  };
};

export default useNotification;
